import { z } from 'zod';

export const WorkspaceTopTaskDismissModalFormSchema = z.object({
  actionNotes: z.string().min(1),
});
